import ServiceCategoryPage from "../components/ServiceCategoryPage";
import painterService from "../data/services/painterService";

function Painter() {
  return <ServiceCategoryPage service={painterService} />;
}

export default Painter;